import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Categories from './pages/Categories';
import Applications from './pages/Applications';
import Configuration from './pages/Configuration';
import Banners from './pages/Banners';
import States from './pages/States';
import Banks from './pages/Banks';
import MyUsers from './pages/MyUsers';
import AgentUsers from './pages/AgentUsers';
import AgentApplications from './pages/AgentApplications';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const App = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="my-users" element={<MyUsers />} />
          <Route path="categories" element={<Categories />} />
          <Route path="applications" element={<Applications />} />
          <Route path="configuration" element={<Configuration />} />
          <Route path="banners" element={<Banners />} />
          <Route path="states" element={<States />} />
          <Route path="banks" element={<Banks />} />
          <Route path="agent-users/:agentId" element={<AgentUsers />} />
          <Route path="agent-applications/:agentId" element={<AgentApplications />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default App; 